export class Video {
  constructor(
    public id: string,
    public nombre: string,
    public descripcion: string,
    public imagen: string,
    public URL: string
  ) { 

  }
}
